<template>
  <div class="table">
    <Table :data="data">
      <TableColumn v-if="$slots.expand" type="expand" width="52">
        <template #default="scope">
          <slot name="expand" :row="scope.row" />
        </template>
      </TableColumn>
      <TableColumn
        v-for="(column, index) in columns"
        :key="index"
        :prop="column.prop"
        :label="column.label"
        :min-width="column.minWidth"
      >
        <template v-if="column.prop === 'upload'" #default="scope">
          <slot name="upload" :row="scope.row" />
        </template>
        <template #header>
          <slot :name="`header-${column.prop}`">{{ column.label }}</slot>
        </template>
      </TableColumn>
    </Table>
  </div>
</template>

<script>
import { ElTable as Table, ElTableColumn as TableColumn } from "element-plus";

export default {
  name: "TableMaster",
  components: {
    Table,
    TableColumn,
  },
  props: {
    data: {
      type: Array,
      required: true,
    },
    columns: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style scoped>
.table {
  font-family: "Globo-Regular";
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}

.el-table {
  border: none;
}

.el-table th,
.el-table td {
  border: none;
}
</style>
